<template>
  <div class="content">
    <!-- 券 -->
    <van-dialog class="ticketDialog" v-model="ticketVisible" :showConfirmButton="false">
      <div class="ticket">
        <h2>{{ money }}</h2>
        <img class="ticket_btn" src="@/assets/img/ticket_btn.png" alt="" @click="ticketClose" />
        <img class="ticket_close" src="@/assets/img/ticket_close.png" alt="" @click="ticketClose" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog, Toast } from 'vant'
Vue.use(Toast)
export default {
  props: {
    money: {
      default: 'Rp0'
    }
  },
  data () {
    return {
      ticketVisible: false
    }
  },
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  created () {
    // 券
    if (!localStorage.getItem('showTicket')) {
      this.ticketVisible = true
    }
  },
  methods: {
    // 券弹窗关闭
    ticketClose () {
      Toast('Berhasil ambil, gunakan pada pinjaman berikutnya')
      localStorage.setItem('showTicket', true)
      setTimeout(() => {
        this.ticketVisible = false
        try {
          if (window.webkit.messageHandlers.tobagus) {
            window.webkit.messageHandlers.tobagus.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.uyeu) {
            window.webkit.messageHandlers.uyeu.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.ghhez) {
            window.webkit.messageHandlers.ghhez.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.uioweiaa) {
            window.webkit.messageHandlers.uioweiaa.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.fgdfgzs) {
            window.webkit.messageHandlers.fgdfgzs.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.dwsd) {
            window.webkit.messageHandlers.dwsd.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.aknvhfjk) {
            window.webkit.messageHandlers.aknvhfjk.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.gerdfz) {
            window.webkit.messageHandlers.gerdfz.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.sdewes) {
            window.webkit.messageHandlers.sdewes.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.ebvhdjs) {
            window.webkit.messageHandlers.ebvhdjs.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.erwer) {
            window.webkit.messageHandlers.erwer.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.kutyjruy) {
            window.webkit.messageHandlers.kutyjruy.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.hfgmny) {
            window.webkit.messageHandlers.hfgmny.postMessage('')
            return
          }
          if (window.webkit.messageHandlers.fsdfwe) {
            window.webkit.messageHandlers.fsdfwe.postMessage('')
            return
          }
        } catch (e) {
          console.log(e)
        }
      }, 700)
      if (!localStorage.getItem('showEvaluate')) {
        this.commentVisible = true
      }
    }
  }
}
</script>

<style scoped lang='less'>
.commentDialog {
  .rise-limit-title {
    .dialog-title;
    padding-left: 24px;
    text-align: left;
    background: none;
    color: #000;
    font-size: 30px;
    font-weight: 600;
  }

  .tip {
    padding-left: 49px;
    padding-right: 49px;
    margin-top: 16px;
    font-size: 26px;
    color: #000;
    text-align: center;
  }

  .toStore-btn {
    .submit-btn;
    width: 500px;
    height: 88px;
    line-height: 88px;
    border-radius: 8px;
    margin: 80px auto 84px;
    font-size: 30px;
    color: #fff;
  }

  .hiddenIcon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.ticketDialog {
  background: none;

  .ticket {
    background: none;
    position: relative;
    height: 900px;
    background: url("~@/assets/img/ticket_bg.png") no-repeat;
    background-size: contain;
    z-index: 9;

    h2 {
      text-align: center;
      padding-top: 335px;
      color: #fb0003;
      font-size: 32px;
    }

    img {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .ticket_btn {
      bottom: 155px;
      width: 300px;
    }

    .ticket_close {
      bottom: 0;
      width: 100px;
    }
  }
}
</style>
